// extracted by mini-css-extract-plugin
export default {"inner":"pool-modal_inner__I8K0p","board":"pool-modal_board__YkWxl","panel":"pool-modal_panel__kH7Si"};